// extracted by mini-css-extract-plugin
export var image = "Teaser-module--image--136b8";
export var teaser = "Teaser-module--teaser--3e5d4";
export var teaserWrapper = "Teaser-module--teaserWrapper--79f98";